enum CheckoutButtonMethodType {
    BRAINTREE_PAYPAL = 'braintreepaypal',
    BRAINTREE_PAYPAL_CREDIT = 'braintreepaypalcredit',
    GOOGLEPAY_BRAINTREE = 'googlepaybraintree',
    GOOGLEPAY_STRIPE = 'googlepaystripe',
    MASTERPASS = 'masterpass',
    PAYPALEXPRESS = 'paypalexpress',
}

export default CheckoutButtonMethodType;
